import React, { useState } from 'react'
import Container from 'components/Container'
import { getSigner } from 'utils'
import InputString from 'components/InputString'
import InputNumber from 'components/InputNumber'
import { CardBody, Button } from '@pancakeswap-libs/uikit'
import { Link as HistoryLink } from 'react-router-dom'
import { RowBetween } from 'components/Row'
import { useTranslation } from 'react-i18next'
import useToast from 'hooks/useToast'
import { BigNumber } from '@ethersproject/bignumber'
// import { useTokenContract } from '../../hooks/useContract'
// import { AutoColumn } from 'components/Column'
// import { Contract } from 'ethers'

import { Contract, utils } from 'ethers'
import { AddressZero } from '@ethersproject/constants'
import AppBody from '../AppBody'
import { Wrapper, InputTitle, InputBox, Title } from './styleds'
import { useActiveWeb3React } from '../../hooks'
import { LOCK_FACTORY } from '../../constants'
import LOCK_FACTORY_ABI from '../../constants/abis/lockFactory.json'
import MINT_TOKEN_ABI from '../../constants/abis/mintToken.json'


export default function CreateMemeProject() {
    const { account, chainId, library } = useActiveWeb3React()
    const { t } = useTranslation()

    const [memeAddress, setMemeAddress] = useState('');
    const [token, setToken] = useState('');
    const [limit, setLimit] = useState(''); 
    const [loading, setLoading] = useState(false);

    const { toastSuccess, toastError } = useToast()
    
    const handleInputMemeAddress = async value => {
      setMemeAddress(value)
    };
    const handleInputToken = async value => {
      setToken(value)
    };

    const handleInputLimit = async value => {
      setLimit(value) 
    }
     const handleRegister = async () => {
      
      if (!chainId || !library || !account) return
      if(Number(limit) < 1000) {
        toastError(t('The number of registered contract addresses must not be less than 1000'))
        return
      }
      if(!utils.isAddress(memeAddress)) {
        toastError(t('The address of the token associated with the transaction is incorrect'))
        return
      }
      if(!utils.isAddress(token)) {
        toastError(t('The address of the option token is incorrect'))
        return
      }
      try {
        const tokenContract = new Contract(memeAddress, MINT_TOKEN_ABI,getSigner(library, account))
        await tokenContract.decimals()
      } catch {
        toastError(t('The address of the token associated with the transaction is incorrect'))
        return
      }
      try {
        const tokenContract = new Contract(token, MINT_TOKEN_ABI,getSigner(library, account))
        await tokenContract.decimals()
      } catch {
        toastError(t('The address of the option token is incorrect'))
        return
      }
       setLoading(true)
       try {
         const contract = new Contract(LOCK_FACTORY, LOCK_FACTORY_ABI,getSigner(library, account))
         const memeInfo: any = await await contract.searchMemeInfo(memeAddress)
         if(memeInfo.memeAddress === AddressZero) {
           toastError(t('The address of the token associated with the transaction is incorrect'))
           return
         }
         if (memeInfo.lockAdderss !== AddressZero) {
           toastError(t('Already created'))
           return
         }
         const tx = await contract.createLockPool(memeAddress, token, limit)
         // eslint-disable-next-line no-console
        //  console.log(tx, 'tx----')
        //  addTransaction(tx, {
        //   summary: `Register token ${tokenAddress}`
        // })
        await tx.wait();
        toastSuccess(t('Created successfully'))
         setLoading(false)
       } catch {
        toastError(t('Created failed'))
         setLoading(false)
       }
     }

    return (
      <Container>
        
        <RowBetween marginBottom='30px' maxWidth="436px">
          <span>  </span>
          <HistoryLink style={{ color:'#29CAD5' }}  to="/projects">{ t('Create record') }</HistoryLink>
        </RowBetween>
      <AppBody>
        <Wrapper>
        <Title>
            { t('One-click create your mining contract') }
          </Title>
          <CardBody>
             <InputBox>
               <InputTitle>{ t('Token address of the associated transaction') }</InputTitle>
               <InputString value={ memeAddress } placeholder={ t('Please enter token address of the associated transaction') } onUserInput={ handleInputMemeAddress }/>
             </InputBox>
             <InputBox>
               <InputTitle>{ t('Option token address') }</InputTitle>
               <InputString value={ token } placeholder={ t('Please enter option token address') } onUserInput={ handleInputToken }/>
             </InputBox>
              <InputBox>
               <InputTitle>{ t('The number of contract addresses registered') }</InputTitle>
               <InputNumber  value={ limit } placeholder={ t('Please enter the number of contract addresses registered') } onUserInput={ handleInputLimit }/>
             </InputBox>
             {/* <WarnTip>
               <span>
                <b>{t('open source code')}</b><br />
                {t('The issued token source code will be automatically verified on the block explorer')}
              </span><br />
             </WarnTip> */}

             {!memeAddress || !token || !limit ? (

                <Button disabled width="100%">{ t('Not all entered') }</Button>
              ) 
              : (<Button width="100%" disabled={ loading } onClick={ handleRegister }>{ loading ? `${t('Create')}...` : t('Create')}</Button>)
            }
            
          </CardBody>
        </Wrapper>
      </AppBody>
    </Container>
    )
  }